import React, { useEffect, useState } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import avatar from "assets/img/avatars/avatar4.png";
import AuthService from "../../service/auth.service";
import PropTypes from "prop-types";

const Navbar = ({ onOpenSidenav, brandText }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userName, setUserName] = useState("Admin");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await AuthService.getProfile();
        setUserName(profile.email ? `${profile.email}` : "User");
      } catch (error) {
        console.error("Failed to fetch profile", error);
      }
    };

    fetchProfile();
  }, []);

  const handleLogout = async () => {
    setLoading(true);
    setError("");

    try {
      AuthService.logout();
      navigate("auth/sign-in");
    } catch (error) {
      console.error("Logout failed", error);
      setError("Échec de la déconnexion. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href="/pages"
          >
            Pages{" "}
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              /
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
      </div>

      <div className="relative mt-[3px] flex h-[61px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-4 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2">
        <button
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </button>
        <div className="flex items-center gap-2">
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            👋 Bonjour, {userName}
          </p>
        </div>

        {/* Profile Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={avatar}
              alt="Profile"
            />
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        >
          <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
            <div className="p-4">
              <div className="flex items-center gap-2">
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  {userName}
                </p>
              </div>
            </div>
            <div className="h-px w-full bg-gray-200 dark:bg-white/20" />
            <div className="flex flex-col p-4">
              <button
                onClick={handleLogout}
                className="mt-3 text-left text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-500 hover:ease-in"
                disabled={loading}
              >
                {loading ? "Déconnexion..." : "Déconnexion"}
              </button>
              {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
            </div>
          </div>
        </Dropdown>
      </div>
    </nav>
  );
};
Navbar.propTypes = {
  onOpenSidenav: PropTypes.func.isRequired,
  brandText: PropTypes.string
};

export default Navbar;
